/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CeleryStatus } from './CeleryStatus';
import { CeleryStatusFromJSON, CeleryStatusFromJSONTyped, CeleryStatusToJSON } from './CeleryStatus';
import type { UserActivityStatus } from './UserActivityStatus';
import {
  UserActivityStatusFromJSON,
  UserActivityStatusFromJSONTyped,
  UserActivityStatusToJSON,
} from './UserActivityStatus';

/**
 * Serializer for overall platform status.
 * @export
 * @interface PlatformStatus
 */
export interface PlatformStatus {
  /**
   *
   * @type {boolean}
   * @memberof PlatformStatus
   */
  isSafeToDeploy: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof PlatformStatus
   */
  reasons: Array<string>;
  /**
   *
   * @type {Date}
   * @memberof PlatformStatus
   */
  checkedAt: Date;
  /**
   *
   * @type {CeleryStatus}
   * @memberof PlatformStatus
   */
  celery: CeleryStatus;
  /**
   *
   * @type {UserActivityStatus}
   * @memberof PlatformStatus
   */
  userActivity: UserActivityStatus;
}

/**
 * Check if a given object implements the PlatformStatus interface.
 */
export function instanceOfPlatformStatus(value: object): value is PlatformStatus {
  if (!('isSafeToDeploy' in value) || value['isSafeToDeploy'] === undefined) return false;
  if (!('reasons' in value) || value['reasons'] === undefined) return false;
  if (!('checkedAt' in value) || value['checkedAt'] === undefined) return false;
  if (!('celery' in value) || value['celery'] === undefined) return false;
  if (!('userActivity' in value) || value['userActivity'] === undefined) return false;
  return true;
}

export function PlatformStatusFromJSON(json: any): PlatformStatus {
  return PlatformStatusFromJSONTyped(json, false);
}

export function PlatformStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformStatus {
  if (json == null) {
    return json;
  }
  return {
    isSafeToDeploy: json['is_safe_to_deploy'],
    reasons: json['reasons'],
    checkedAt: new Date(json['checked_at']),
    celery: CeleryStatusFromJSON(json['celery']),
    userActivity: UserActivityStatusFromJSON(json['user_activity']),
  };
}

export function PlatformStatusToJSON(value?: PlatformStatus | null): any {
  if (value == null) {
    return value;
  }
  return {
    is_safe_to_deploy: value['isSafeToDeploy'],
    reasons: value['reasons'],
    checked_at: value['checkedAt'].toISOString(),
    celery: CeleryStatusToJSON(value['celery']),
    user_activity: UserActivityStatusToJSON(value['userActivity']),
  };
}
